// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Renderer__Accessor from "./Renderer__Accessor.bs.js";

function getValueFromJson(json, indexer) {
  if (indexer.TAG === "Field") {
    var key = indexer._0;
    return Core__Option.flatMap(Core__JSON.Decode.object(json), (function (__x) {
                  return __x[key];
                }));
  }
  var position = indexer._0;
  return Core__Option.flatMap(Core__JSON.Decode.array(json), (function (__x) {
                return __x[position];
              }));
}

function extractValue(json, path) {
  return Renderer__Accessor.extractValue(path, getValueFromJson, json);
}

var updateValue = Renderer__Accessor.setValueJSON;

export {
  extractValue ,
  updateValue ,
}
/* No side effect */
